import React from 'react'
import makeStyles from '@material-ui/core/styles/makeStyles'
import AppCard from 'components/app-card'
import headerImage from 'images/landing-jr-league-header.png'
import logo from 'images/jr-league-logo.svg'
import { signup } from 'lib/junior-league-utils/routes'

const useStyles = makeStyles({
  brandLogo: {
    display: 'block',
    height: 48,
    width: 'auto',
  },
})

export default function JrLeague() {
  const classes = useStyles()

  return (
    <AppCard
      title="Manage teams, players, and registrations."
      to={signup}
      buttonText="Open PGA Jr. League"
      testid="jr-league-tile"
      headerImage={headerImage}
      headerImageAlt="Junior golfers walking on a course with golf bags"
      headerImagePosition="center 35%"
      brand={
        <img src={logo} alt="PGA Jr. League" className={classes.brandLogo} />
      }
    />
  )
}
